import FaqCategory from '../FaqCategory';

export default class SiteFaqCategory extends FaqCategory {
    isHidden: boolean = false;
}
